<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (confirm)="confirm($event)"
  (cancel)="cancel()"
  (alt)="alt()"
>
  <div class="flex--container" style="min-width: 300px">
    <h4>{{ 'isPrecedingCrop' | translate }}</h4>
    <div>
      <div class="mat-slide-group">
        <mat-slide-toggle
          color="primary"
          formControlName="isPrecedingCrop"
          data-test="fertilization-setting-is-preceding-crop"
          >{{ 'isPrecedingCrop' | translate }}</mat-slide-toggle
        >
      </div>
    </div>

    @if (isPrecedingCrop()) {
      <app-preceding-crop-settings
        [precedingCropFormGroup]="precedingCropFormGroup"
        [crops]="data.crops"
        data-test="fertilization-setting-preceding-crop-settings"
      ></app-preceding-crop-settings>
    }

    <h4>{{ 'isGreenManure' | translate }}</h4>
    <div>
      <div class="mat-slide-group">
        <mat-slide-toggle
          color="primary"
          formControlName="isGreenManure"
          data-test="fertilization-setting-is-green-manure"
          >{{ 'isGreenManure' | translate }}</mat-slide-toggle
        >
      </div>
    </div>

    @if (isGreenManure()) {
      <app-green-manure-settings
        [crops]="data.greenManureCrops"
        [greenManureFormGroup]="greenManureFormGroup"
        data-test="fertilization-setting-green-manure-settings"
      ></app-green-manure-settings>
    }

    <h4>{{ 'shouldBeUsed' | translate }}</h4>
    <div>
      <div class="mat-slide-group">
        <mat-slide-toggle
          color="primary"
          formControlName="shouldBeUsedInUsageStandard"
          data-test="fertilization-setting-should-be-used-in-usage-standard"
          >{{ 'shouldBeUsedInUsageStandard' | translate }}</mat-slide-toggle
        >
      </div>
    </div>
    <div>
      <div class="mat-slide-group">
        <mat-slide-toggle
          color="primary"
          formControlName="shouldBeUsedInLegalStandard"
          data-test="fertilization-setting-should-be-used-in-legal-standard"
          >{{ 'shouldBeUsedInLegalStandard' | translate }}</mat-slide-toggle
        >
      </div>
    </div>

    @if ((cropYear$ | async) < 2025) {
      <div>
        <h4>{{ 'phosphateArrangements' | translate }}</h4>
        <div>
          <div class="mat-slide-group">
            <mat-slide-toggle
              color="primary"
              formControlName="shouldUseTransitionalArrangement"
              data-test="fertilization-setting-should-use-transitional-arrangement"
              >{{ 'shouldUseTransitionalArrangement' | translate }}</mat-slide-toggle
            >
          </div>
        </div>
        <div>
          <div class="mat-slide-group">
            <mat-slide-toggle
              color="primary"
              formControlName="shouldUseLowInPhosphateArrangement"
              data-test="fertilization-setting-should-use-low-in-phosphate-arrangement"
              >{{ 'shouldUseLowInPhosphateArrangement' | translate }}</mat-slide-toggle
            >
          </div>
        </div>
      </div>
    }

    <h4>{{ 'nitrogenUsageStandard' | translate }}</h4>
    <div>
      <app-nitrogen-calculation-settings
        [nitrogenCalculationSettingsFormGroup]="nitrogenCalculationSettingsFormGroup"
        [nitrogenCalculationSettingToggles]="nitrogenCalculationSettingToggles$ | async"
      ></app-nitrogen-calculation-settings>
    </div>

    @if ((nitrogenCalculationSettingToggles$ | async)?.shouldShowOrganicMatterToggle) {
      <div>
        <h4>{{ 'organicMatter' | translate }}</h4>
        <div class="flex__child--auto">
          <mat-form-field class="full-width-field">
            <mat-label>
              {{ 'organicMatterSupply' | translate }}
            </mat-label>
            <mat-select
              formControlName="organicMatterSupply"
              [placeholder]="'organicMatterSupply' | translate"
              data-test="fertilization-setting-organic-matter-supply"
            >
              @for (organicMatterSupply of organicMatterSupplyKeys; track organicMatterSupply) {
                <mat-option [value]="organicMatterSupply">{{
                  organicMatterSupply.toLowerCase() | translate
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }

    <mat-form-field class="full-width-field">
      <mat-label> {{ 'expectedCropYield' | translate }} (T) </mat-label>
      <input
        matInput
        agrNumber
        maxlength="10"
        [placeholder]="'expectedCropYield' | translate"
        formControlName="expectedCropYield"
        data-test="fertilization-setting-expected-crop-yield"
        [step]="0.1"
        autocomplete="off"
      />
    </mat-form-field>
  </div>
</agr-form-dialog>
